<template>
    <tr>
        <td>
            <img :src="getAvatar(worker.photo)" alt="" class="avatar">
            <span>{{worker.surname}} {{ worker.name }}</span>
        </td>
        <td v-if="worker.supervisor && token != worker.token">
            <app-select :options="type == 2 ? purchaser_roles : provider_roles" :value="role" @input="changeRoleUser($event, worker)" no_border/>
        </td>
        <td v-if="worker.supervisor && token == worker.token">
            {{worker.position}}
        </td>
        <td v-if="!worker.supervisor">
            <span class="admin-role">Администратор</span>
        </td>
        <td>{{ worker.phone }}</td>
        <td>{{ worker.email }}</td>
        <td class="action">
<!--            <button>-->
<!--                <img src="@/assets/img/worker/lock.svg" alt="">-->
<!--            </button>-->
            <button @click="$emit('change', worker)" v-if="!worker.current && token != worker.token">
                <img class="hover_btn" src="@/assets/img/worker/delete.svg" alt="">
            </button>
<!--            <button @click="$emit('invite', worker.id)" v-else>-->
<!--                <img class="hover_btn" src="@/assets/img/worker/delete.svg" alt="">-->
<!--            </button>-->
        </td>
    </tr>
</template>

<script>
import AppSelect from "@/components/app-select";
export default {
  name: "WorkerTable",
  components: { AppSelect },
  props: ['worker'],
  data: (data) => ({
    role: data.worker.position,
    provider_roles: ['Руководитель отдела', 'Менеджер по продажам', 'Менеджер клиентской поддержки', 'Менеджер по дропшиппингу'],
    purchaser_roles: ['Руководитель отдела', 'Старший менеджер по закупкам', 'Менеджер по закупкам'],
    type: '',
    token: ''
  }),
  mounted() {
    this.type = localStorage.getItem('type');
    this.token =  localStorage.getItem('token');
  },
  methods:{
    changeRoleUser(val, worker){
      this.$emit('changeRole', {'role': val, 'id': worker.id})
    },
    getAvatar(avatar){
      if(avatar == 'https://api.superbaer24.ru/storage/' || avatar == null) return require('@/assets/icons/user.svg')
      else return avatar
    }
  }
}
</script>

<style lang="scss">
.vs__dropdown-toggle {
    border: unset !important;
    padding: 0 !important;
}

.vs4__listbox {
    background: #FFFFFF !important;
    box-shadow: 0px 0px 3px #E5E5EA!important;
    border-radius: 0px 0px 4px 4px!important;
    padding: 0 !important;
    word-wrap: normal !important;

    &:hover {
        background: unset;
    }
}

.vs__dropdown-option--highlight{background:unset !important;color:unset !important;}

.vs__dropdown-option {
    word-wrap: normal !important;
    word-break: normal !important;
    white-space: normal !important;
    padding: 8px 15px !important;

    font-size: 12px;
    line-height: 14px;
    color: #2D3137;

    &:hover {
        background: none;
    }

    &:not(:last-child) {
        border: 1px solid #EEF0F3;
    }
}

.vs__selected {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    display: block;
    margin: 0;
    padding: 0;
    color: #7A818F;
    font-size: 14px;
}

.vs__selected-options {
    align-items: center;
}
</style>

<style scoped lang="scss">
.admin-role {
    margin-left: 10px;
}
th, td {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 7px 14px;
    height: 40px;
    text-align: left;

    &:not(:last-child) {
        border-right: 1px #a3a3a3 solid;
    }
}

th {
    color: #2D3137;
}

tr {
    color: #7A818F;

    &:nth-child(even) {
        background: #F9F9FB;
    }
}

.action {
    display: flex;
    justify-content: center;
    align-items: center;

    button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;

        > img {
            width: 100%;
            height: 100%;
        }
    }
}

.avatar {
    width: 26px;
    height: 26px;
    object-fit: cover;
    border-radius: 100%;
    vertical-align: middle;
    margin-right: 10px;
}

.role {
    width: 265px;

    .v-select {
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        color: #7A818F;
        font-size: 14px;
        box-shadow: none;
        min-height: unset !important;
    }
}
</style>
